import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  locale: document.documentElement.lang,
  messages: {
    cs: {

    },
    en: {

    },
  },
})
